import {
  ParticipantCourse,
  ParticipantCourses,
} from 'models/participantCourse.model'
import api from '../..'

export const getCourses = (userId: number) => {
  return api.get(`administration/users/${userId}/courses`).then(
    ({ data: { data } }): ParticipantCourses => ({
      id: userId,
      courses: data.map(
        ({
          attributes: {
            lmsProfiles,
            advance,
            lmsProfileType,
            course,
            courseId: id,
            enrol: { data: enrol },
          },
        }: any): ParticipantCourse => {
          const { name, state } = course
          return {
            id,
            name,
            state,
            lmsProfileType,
            advance,
            lmsProfiles,
            enrol,
          }
        }
      ),
    })
  )
}
